import React from 'react';
import { PokemonIcon } from './PokemonIcon';
export function Header({
  activeSection,
  onNavigate
}) {
  const navItems = [{
    id: 'description',
    label: 'Description'
  }, {
    id: 'typeAdvantages',
    label: 'Type Advantages'
  }, {
    id: 'news',
    label: 'News'
  }, {
    id: 'youtubeChannels',
    label: 'YouTube'
  }, {
    id: 'fanspace',
    label: 'Fanspace'
  }, {
    id: 'guessThatPokemon',
    label: 'Guess That Pokémon!'
  }, {
    id: 'shop',
    label: 'PokéShop'
  }, {
    id: 'wardrobe',
    label: 'Wardrobe'
  }, {
    id: 'pokedex',
    label: 'Pokédex'
  }];
  return <header className="sticky top-0 z-20 bg-white/90 dark:bg-slate-900/80 backdrop-blur-sm border-b border-slate-200 dark:border-slate-700 shadow-lg transition-colors duration-300" data-id="element-163">
      <div className="container mx-auto px-4 py-4 max-w-5xl" data-id="element-164">
        <div className="flex items-center justify-center mb-4" data-id="element-165">
          <div className="flex items-center" data-id="element-166">
            <PokemonIcon className="w-10 h-10 mr-2" data-id="element-167" />
            <h1 className="text-4xl md:text-5xl font-bold text-center bg-gradient-to-b from-red-600 to-slate-800 dark:from-red-600 dark:to-white bg-clip-text text-transparent" data-id="element-168">
              The Pokémon User Manual
            </h1>
            <PokemonIcon className="w-10 h-10 ml-2" data-id="element-169" />
          </div>
        </div>
        <nav className="flex justify-center flex-wrap" data-id="element-170">
          {navItems.map(item => <button key={item.id} onClick={() => onNavigate(item.id)} className={`px-4 py-2 mx-2 rounded-full transition-colors ${activeSection === item.id ? 'bg-red-600 text-white' : 'bg-slate-200 hover:bg-slate-300 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-800 dark:text-gray-200'}`} data-id="element-171">
              {item.label}
            </button>)}
        </nav>
      </div>
    </header>;
}